type Props = { password: string };
export const validPasswordRegexPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>/?])(?=.*[a-zA-Z\d!@#$%^&*()\-_=+{};:,<.>/?]).{8,}$/;

export default function PasswordChecklist({ password }: Props) {
  const rules = [
    { desc: "At least 8 characters", regex: /^.{8,}$/ },
    { desc: "At least 1 lowercase character", regex: /[a-z]/ },
    { desc: "At least 1 UPPERCASE character", regex: /[A-Z]/ },
    { desc: "At least 1 number", regex: /[0-9]/ },
    {
      desc: "At least 1 special character (e.g., ! @ # ?)",
      regex: /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
    },
  ];
  // var currentBrokenRules = [];
  // function refreshPasswordRequirements() {
  //   var parts = [];

  //   if (password.length < 8) parts.push("8 char minimum");

  //   var hasNumberformat = /[0-9]/;
  //   if (hasNumberformat.test(password) == false) parts.push("1 number");

  //   var hasSpecialCharacterformat = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  //   if (hasSpecialCharacterformat.test(password) == false)
  //     parts.push("1 special character");

  //   var hasLowerformat = /[a-z]/;
  //   if (hasLowerformat.test(password) == false)
  //     parts.push("1 lowercase character");

  //   var hasUpperformat = /[A-Z]/;
  //   if (hasUpperformat.test(password) == false)
  //     parts.push("1 UPPERCASE character");
  //   // const finalTitle =
  //   //   "Create a password" +
  //   //   (parts.length > 0 ? " (" + parts.join(", ") + ")" : " ✓");
  //   // setSignupTitle(finalTitle);
  // }
  return (
    <div className="mt-5 rounded-md bg-secondary-content p-2">
      <ul className="max-w-md list-inside space-y-1 ">
        {rules.map((rule, index) => {
          const passed = rule.regex.test(password);

          return (
            <li
              key={index}
              className={`flex items-center ${
                passed ? "text-success " : " text-error "
              }`}
            >
              <svg
                className={`mr-1.5 h-4 w-4 flex-shrink-0 ${
                  passed ? "text-success " : " text-error "
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d={`${
                    passed
                      ? "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      : "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  } `}
                  clipRule="evenodd"
                ></path>
              </svg>
              {rule.desc}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
